import { Fragment } from "react";

import { noop } from "neetocist";
import { joinHyphenCase } from "neetocommons/utils/general";
import { Braces } from "neetoicons";
import { Dropdown, Typography } from "neetoui";
import PropTypes from "prop-types";
import { isEmpty } from "ramda";

import "./dynamic-variables.scss";
import { parseVariables } from "./utils";

const { Menu } = Dropdown;

const DynamicVariables = ({
  onVariableClick = noop,
  variables = [],
  buttonProps,
  ...dropdownProps
}) => {
  if (isEmpty(variables)) {
    return null;
  }

  const parsedVariables = parseVariables(variables);

  return (
    <Dropdown
      appendTo={() => document.body}
      buttonStyle="secondary"
      icon={Braces}
      strategy="fixed"
      zIndex={99999}
      buttonProps={{
        "data-testid": "dynamic-variables-button",
        ...buttonProps,
      }}
      {...dropdownProps}
    >
      <Menu>
        <div
          className="neeto-molecules-dynamic-variables"
          data-testid="dynamic-variables-list"
        >
          {parsedVariables.map(({ label, variables }) => (
            <Fragment key={label}>
              {label && (
                <div className="flex flex-row items-center gap-x-2">
                  <Typography style="h6">{label}</Typography>
                  <hr className="neeto-ui-border-gray-200 flex flex-grow" />
                </div>
              )}
              <div
                className="neeto-molecules-dynamic-variables__list"
                data-testid={joinHyphenCase("dynamic-variables-list", label)}
              >
                {variables.map(item => (
                  <button
                    key={item.label}
                    data-testid={joinHyphenCase(
                      "dynamic-variables-list-item",
                      item.label
                    )}
                    onClick={() => onVariableClick(item)}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </Fragment>
          ))}
        </div>
      </Menu>
    </Dropdown>
  );
};

DynamicVariables.propTypes = {
  /**
   * A function that is triggered when a dynamic variable button is clicked. It receives an object containing information about the clicked variable.
   */
  onVariableClick: PropTypes.func,
  /**
   * An array of objects, each representing a category or standalone variable, with the ability to define a label, key, and default value for each variable.
   */
  variables: PropTypes.arrayOf(
    PropTypes.shape({ label: PropTypes.string, key: PropTypes.string })
  ),
};

export default DynamicVariables;
